import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';

const JiraFrontierAgentPanelHeadingAddAgentButton = {
	get(): boolean {
		// The collapsible agent section also needs `AgentPanelHeading_issue` (for the project key
		// that scopes its persisted state), and it ships on an independent gate. `expVal` stays
		// first so the add-agent experiment's exposure still fires exactly as before.
		return (
			expVal('jira_agent_panel_heading_add_agent_button', 'isEnabled', false) ||
			fg('mwiv_empty_state_redesign_gate_2')
		);
	},
};

export default JiraFrontierAgentPanelHeadingAddAgentButton;
